import React, { useRef } from 'react';
import classNames from 'classnames';
import useEffectSkipFirst from 'hooks/useEffectSkipFirst';
import env from 'env';
import mapboxgl from 'mapbox-gl';
import useCallbackRef from 'hooks/useCallbackRef';

import 'mapbox-gl/dist/mapbox-gl.css';

import './StaticMapPreview.styles.scss';
import './StaticMapPreview.styles.responsive.scss';

const DEFAULT_ZOOM = 4;
type StaticMapPreviewProps = {
  className?: string;
  coordinates: [number, number];
  zoom?: number;
};

mapboxgl.accessToken = env.MAPBOXGL_ACCESS_TOKEN || '';

const StaticMapPreview: React.FC<StaticMapPreviewProps> = (props) => {
  const { className, coordinates, zoom = DEFAULT_ZOOM } = props;
  const [lng, lat] = coordinates;
  const [mapContainer, mapContainerRef] = useCallbackRef(null);
  const map = useRef<mapboxgl.Map>();

  const classes = classNames('static-map-preview', className);

  useEffectSkipFirst(() => {
    if (mapContainer)
      map.current = new mapboxgl.Map({
        container: mapContainer,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [lng, lat],
        zoom: zoom,
        dragRotate: false,
      });

    new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map.current);
  }, [lat, lng, zoom, mapContainer]);

  return (
    <div className={classes}>
      <div ref={mapContainerRef} className="fm-map-container" />
    </div>
  );
};

export default StaticMapPreview;
